module.exports = __webpack_public_path__ + "resources/img/mark_csap_lg.ac4e06a997dab93cb64972f281af6d24.png";